export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  coverImage: string;
  author: string;
  publishDate: string;
  tags: string[];
  featured: boolean;
  viewCount: number;
}

export const categories: { slug: string; name: string; description: string; icon: string }[] = [
  { slug: 'news', name: '最新资讯', description: '朝桐光最新动态与新闻', icon: 'ri-newspaper-line' },
  { slug: 'works', name: '作品全集', description: '朝桐光所有作品介绍与回顾', icon: 'ri-movie-2-line' },
  { slug: 'photos', name: '写真图集', description: '朝桐光高清写真与精美图集', icon: 'ri-gallery-line' },
  { slug: 'community', name: '粉丝社区', description: '粉丝讨论、活动与互动', icon: 'ri-user-heart-line' },
  { slug: 'interviews', name: '专访报道', description: '朝桐光独家访谈与媒体报道', icon: 'ri-mic-line' },
];

export const articles: Article[] = [
  {
    id: 'news-2025-01',
    title: '朝桐光最新电影《樱花之约》正式预告发布，预计明年春季上映',
    excerpt: '朝桐光主演的最新浪漫电影《樱花之约》今日正式发布首款预告片，影片讲述了一段跨越时空的唯美爱情故事，朝桐光在片中饰演女主角樱井葵，展现了精湛的演技与独特的魅力。影片预计于2026年春季在日本全国上映。',
    content: `
      <p>备受期待的浪漫电影《樱花之约》今日发布了首款正式预告片，朝桐光作为女主角在这部作品中展现了令人惊艳的表演。该片由知名导演山田健一执导，是朝桐光继《东京夜曲》之后的又一力作。</p>
      
      <h3>剧情简介</h3>
      <p>《樱花之约》讲述了一位现代女性樱井葵（朝桐光饰）在一次意外中穿越回昭和时代的京都，与一位青年画家相遇相知的爱情故事。影片通过两个时空的交错，展现了跨越时代的真挚情感。</p>
      
      <h3>制作团队</h3>
      <p>该片由日本著名导演山田健一执导，他曾凭借《京都物语》获得日本电影学院奖最佳导演奖。编剧由《恋空》编剧团队操刀，音乐由坂本龙一弟子小林武史创作。</p>
      
      <h3>朝桐光访谈片段</h3>
      <p>朝桐光在接受采访时表示："樱井葵这个角色对我来说是一个全新的挑战，她身上有着现代女性的独立与坚韧，同时也保留着传统日本女性的温柔。我非常享受演绎这个角色的过程。"</p>
      
      <p>据悉，影片目前已完成主要拍摄工作，正在进行后期制作。朝桐光在拍摄期间每日坚持提前两小时到达片场进行准备工作，其敬业精神获得了全剧组的一致好评。</p>
      
      <h3>上映信息</h3>
      <p>《樱花之约》预计将于2026年3月在日本全国上映，随后将在亚洲多个国家和地区陆续上映。粉丝们纷纷表示期待，社交媒体上相关话题讨论热度持续攀升。</p>
    `,
    category: 'news',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20actress%20elegant%20portrait%20in%20cherry%20blossom%20garden%2C%20soft%20natural%20lighting%2C%20warm%20atmosphere%2C%20minimalist%20aesthetic%2C%20professional%20editorial%20photography%20with%20dreamy%20bokeh%20background%2C%20clean%20composition%2C%20serene%20expression&width=800&height=450&seq=asa-news-01&orientation=landscape',
    author: '编辑部',
    publishDate: '2025-12-15',
    tags: ['电影', '樱花之约', '预告', '主演'],
    featured: true,
    viewCount: 12580,
  },
  {
    id: 'news-2025-02',
    title: '朝桐光荣获年度最受欢迎女艺人奖，感言感动全场',
    excerpt: '在昨晚举行的年度娱乐大奖颁奖典礼上，朝桐光凭借出色的表现荣获"年度最受欢迎女艺人"大奖。她在获奖感言中感谢了所有支持她的粉丝和工作人员，真挚的话语令全场动容。',
    content: `
      <p>在昨晚于东京国际论坛举行的第15届年度娱乐大奖颁奖典礼上，朝桐光荣膺"年度最受欢迎女艺人"大奖。这一奖项由粉丝投票和专业评审共同决定，充分体现了朝桐光在演艺圈的广泛影响力。</p>
      
      <h3>获奖感言</h3>
      <p>朝桐光身着由日本知名设计师山本耀司定制的黑色晚礼服登上领奖台，优雅从容地发表了获奖感言。她表示："能够获得这个奖项，我感到无比的荣幸和感激。这份荣誉属于每一位支持我的粉丝，属于每一位与我并肩工作的伙伴。未来的日子里，我会继续努力，用更好的作品回馈大家的厚爱。"</p>
      
      <h3>现场盛况</h3>
      <p>颁奖典礼现场星光熠熠，众多日本演艺界知名人士出席。当主持人宣布朝桐光获奖时，全场响起了经久不息的掌声。多位圈内好友纷纷在社交媒体上送上祝福。</p>
      
      <p>值得一提的是，朝桐光在颁奖典礼后的记者采访中透露，她正在筹备一部全新的电视剧作品，预计将在明年与观众见面。这一消息令粉丝们激动不已。</p>
    `,
    category: 'news',
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20Japanese%20actress%20in%20black%20evening%20gown%20at%20award%20ceremony%2C%20sophisticated%20atmosphere%2C%20warm%20stage%20lighting%2C%20editorial%20photography%2C%20clean%20minimal%20aesthetic%2C%20graceful%20pose&width=800&height=450&seq=asa-news-02&orientation=landscape',
    author: '编辑部',
    publishDate: '2025-12-10',
    tags: ['获奖', '年度大奖', '感言'],
    featured: true,
    viewCount: 18920,
  },
  {
    id: 'works-2025-01',
    title: '朝桐光作品回顾：《东京夜曲》——都市夜色中的灵魂独白',
    excerpt: '《东京夜曲》是朝桐光演艺生涯中具有里程碑意义的作品。在这部聚焦都市青年情感的电影中，朝桐光以细腻入微的表演刻画了一个在东京漂泊的女性形象，获得了评论界的一致赞誉。',
    content: `
      <p>《东京夜曲》于2024年上映，是朝桐光演艺生涯中最重要的作品之一。这部由新锐导演佐藤健太执导的都市情感电影，以东京夜晚为背景，讲述了一群年轻人在大都市中寻找自我与爱情的故事。</p>
      
      <h3>角色分析</h3>
      <p>朝桐光在片中饰演女主角美咲——一位从地方城市来到东京追逐梦想的年轻女性。美咲这个角色充满了矛盾与张力：她既渴望都市的繁华与机会，又在钢筋水泥的丛林中感到孤独与迷茫。朝桐光通过细腻的面部表情和肢体语言，将这个角色的内心世界展现得淋漓尽致。</p>
      
      <h3>表演亮点</h3>
      <p>影片中最令人印象深刻的场景是美咲在深夜的东京街头独自漫步的长镜头。朝桐光在三分钟的连续拍摄中，仅凭眼神和步态的微妙变化，就传达出角色从迷惘到坚定、从绝望到希望的完整情感弧线。这场戏被多位影评人誉为"年度最佳表演片段之一"。</p>
      
      <h3>媒体评价</h3>
      <p>《电影旬报》评价道："朝桐光的表演如同东京夜色中的一盏灯，温暖而坚定。她让美咲这个角色超越了银幕的界限，成为每一个在大城市中奋斗的年轻人的缩影。"</p>
      
      <p>《读卖新闻》则称："这是朝桐光演技成熟的标志性作品，她成功摆脱了早期作品中青涩的痕迹，展现出令人惊叹的角色驾驭能力。"</p>
      
      <h3>获奖情况</h3>
      <p>凭借《东京夜曲》中的出色表现，朝桐光获得了第48届日本电影学院奖最佳女主角提名，并最终斩获第36届横滨电影节最佳女演员奖。</p>
    `,
    category: 'works',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20actress%20contemplative%20portrait%20in%20Tokyo%20night%20street%2C%20soft%20neon%20glow%2C%20urban%20atmosphere%2C%20cinematic%20lighting%2C%20minimalist%20aesthetic%2C%20emotional%20expression%2C%20warm%20amber%20tones&width=800&height=450&seq=asa-works-01&orientation=landscape',
    author: '影评部',
    publishDate: '2025-11-28',
    tags: ['作品回顾', '东京夜曲', '电影', '演技'],
    featured: true,
    viewCount: 8920,
  },
  {
    id: 'works-2025-02',
    title: '朝桐光作品回顾：《京都恋歌》——古都中的浪漫诗篇',
    excerpt: '在《京都恋歌》中，朝桐光化身京都传统和果子店的继承人，与一位来自东京的建筑师展开了一段跨越文化差异的浪漫旅程。这部作品展现了朝桐光演绎传统与现代交融角色的独特魅力。',
    content: `
      <p>《京都恋歌》是朝桐光2024年主演的日剧作品，全剧共10集，在富士电视台播出期间获得了极高的收视率和口碑。该剧以京都为舞台，将传统文化与现代爱情完美融合。</p>
      
      <h3>角色定位</h3>
      <p>朝桐光在剧中饰演京都百年和果子老店"桜月堂"的独生女桜井千夏。千夏从小在传统氛围中长大，精通和果子的制作技艺，但同时也怀揣着将家族事业现代化的梦想。</p>
      
      <h3>剧集亮点</h3>
      <p>剧中不仅有动人的爱情故事，还大量展现了京都的四季美景和日本传统和果子文化。朝桐光在剧中亲自学习和果子的制作，许多制作场景都是她亲身上阵，展现了对角色的全情投入。</p>
      
      <h3>收视表现</h3>
      <p>《京都恋歌》播出期间平均收视率达到14.8%，大结局更是创下了18.2%的收视高峰，成为当季收视冠军。该剧在中国、韩国、台湾等亚洲地区也获得了极高的关注度。</p>
    `,
    category: 'works',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20actress%20in%20traditional%20kimono%20in%20Kyoto%20old%20street%2C%20soft%20sunlight%20filtering%20through%20trees%2C%20warm%20natural%20tones%2C%20elegant%20traditional%20atmosphere%2C%20cinematic%20composition&width=800&height=450&seq=asa-works-02&orientation=landscape',
    author: '影评部',
    publishDate: '2025-11-20',
    tags: ['作品回顾', '京都恋歌', '日剧', '和果子'],
    featured: false,
    viewCount: 7560,
  },
  {
    id: 'photos-2025-01',
    title: '朝桐光2025秋冬写真特辑：时光的痕迹',
    excerpt: '朝桐光最新秋冬写真特辑"时光的痕迹"正式发布。这组写真由日本著名摄影师荒木经惟掌镜，以极简主义风格呈现了朝桐光在不同光线与场景下的独特气质，展现了岁月沉淀后的成熟魅力。',
    content: `
      <p>朝桐光2025秋冬写真特辑"时光的痕迹"于近日正式发布。这组写真由享誉国际的日本摄影师荒木经惟掌镜，历时三个月拍摄完成。</p>
      
      <h3>创作理念</h3>
      <p>本次写真特辑以"时光"为主题，通过不同季节、不同时间段的自然光线，捕捉朝桐光在时光流转中的多样面貌。从清晨第一缕阳光下的清新，到黄昏时分金色光芒中的温柔，再到深夜月光下的神秘——每一帧画面都是时光的凝固。</p>
      
      <h3>拍摄花絮</h3>
      <p>拍摄地点横跨日本多个标志性场景，包括北海道的雪原、京都的古寺、冲绳的海岸和东京的城市天台。朝桐光在零下十度的北海道雪地中坚持拍摄四小时，只为捕捉最完美的雪景瞬间，其专业精神令人敬佩。</p>
      
      <h3>公开发售</h3>
      <p>写真特辑将于12月20日在日本全国各大书店及线上平台同步发售，限量版还附赠朝桐光亲笔签名的收藏卡片。预售通道开放首日即创下了该出版社写真类书籍的预售纪录。</p>
    `,
    category: 'photos',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20actress%20artistic%20portrait%20in%20winter%20snow%20landscape%2C%20minimalist%20composition%2C%20soft%20diffused%20lighting%2C%20elegant%20warm%20coat%2C%20serene%20expression%2C%20professional%20fashion%20photography%2C%20clean%20white%20background&width=800&height=450&seq=asa-photos-01&orientation=landscape',
    author: '写真部',
    publishDate: '2025-12-08',
    tags: ['写真', '秋冬', '特辑', '荒木经惟'],
    featured: true,
    viewCount: 15340,
  },
  {
    id: 'photos-2025-02',
    title: '朝桐光夏日海滩写真集《海风的诗》精选预览',
    excerpt: '朝桐光今年夏季在冲绳拍摄的海滩写真集《海风的诗》精选画面首次公开。碧海蓝天下，朝桐光以自然清新的形象展现了与都市形象截然不同的活力与阳光气质。',
    content: `
      <p>朝桐光夏季写真集《海风的诗》精选画面于今日首次公开。这组在冲绳宫古岛拍摄的写真展现了朝桐光活力四射、阳光自然的一面。</p>
      
      <h3>写真主题</h3>
      <p>《海风的诗》以"自然、自由、自在"为核心理念，朝桐光在碧海蓝天之间自由漫步，展现了最真实、最放松的状态。此次写真完全采用自然光拍摄，不使用任何人工照明，力求呈现最纯粹的画面质感。</p>
      
      <h3>幕后故事</h3>
      <p>拍摄期间恰逢冲绳最美的季节，海水清澈见底，天空湛蓝如洗。朝桐光表示这是她最享受的一次拍摄经历："在这里，我感觉自己完全融入了大自然，每一张照片都是内心真实的表达。"</p>
    `,
    category: 'photos',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20actress%20natural%20portrait%20at%20tropical%20beach%2C%20sunlight%20and%20ocean%20waves%2C%20fresh%20natural%20vibe%2C%20minimalist%20summer%20aesthetic%2C%20soft%20warm%20lighting%2C%20clean%20composition&width=800&height=450&seq=asa-photos-02&orientation=landscape',
    author: '写真部',
    publishDate: '2025-12-05',
    tags: ['写真', '夏日', '海滩', '冲绳'],
    featured: false,
    viewCount: 11200,
  },
  {
    id: 'community-2025-01',
    title: '朝桐光官方粉丝俱乐部五周年庆典盛大举行',
    excerpt: '朝桐光官方粉丝俱乐部成立五周年庆典于上周末在东京盛大举行。朝桐光亲临现场与粉丝互动，现场气氛温馨热烈，近千名来自日本及海外的幸运粉丝参与了这场难忘的盛会。',
    content: `
      <p>朝桐光官方粉丝俱乐部"光之庭"成立五周年庆典于上周末在东京品川王子酒店盛大举行。近千名经过抽选获得入场资格的粉丝齐聚一堂，共同庆祝这一重要时刻。</p>
      
      <h3>活动亮点</h3>
      <p>庆典活动包含多个精彩环节。朝桐光首先以一曲钢琴独奏开场，展现了其多才多艺的一面。随后进行了粉丝问答环节，朝桐光真诚地回答了粉丝们提出的各种问题，从工作近况到日常生活，不设限制地与粉丝分享。</p>
      
      <h3>特别企划</h3>
      <p>活动现场还特别设置了"五年回顾"展示区，展出了朝桐光五年来的经典剧照、获奖奖杯复刻品以及珍贵的幕后花絮照片。许多粉丝在展示区驻足良久，共同回忆这五年来的美好时光。</p>
      
      <h3>粉丝感言</h3>
      <p>一位从大阪专程赶来的粉丝激动地表示："我从朝桐光出道第一天就开始支持她，看到她一步步成长到今天，我感到无比骄傲。她不仅仅是一位优秀的艺人，更是我们粉丝心中的光。"</p>
    `,
    category: 'community',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20actress%20warmly%20interacting%20with%20fans%20at%20fan%20event%2C%20soft%20stage%20lighting%2C%20joyful%20atmosphere%2C%20elegant%20setting%2C%20editorial%20photography%2C%20warm%20golden%20tones&width=800&height=450&seq=asa-comm-01&orientation=landscape',
    author: '社区部',
    publishDate: '2025-12-01',
    tags: ['粉丝俱乐部', '五周年', '庆典', '互动'],
    featured: false,
    viewCount: 9870,
  },
  {
    id: 'community-2025-02',
    title: '粉丝创作大赛获奖作品展示：朝桐光的千百种模样',
    excerpt: '由官方粉丝社区发起的"朝桐光的千百种模样"粉丝创作大赛圆满落幕。来自全球各地的粉丝通过绘画、摄影、文学等形式表达了对朝桐光的热爱，获奖作品展现了令人惊叹的创意与才华。',
    content: `
      <p>历时一个月的"朝桐光的千百种模样"粉丝创作大赛于近日圆满结束。本次大赛共收到来自日本、中国、韩国、台湾、美国等十余个国家和地区的近两千件参赛作品。</p>
      
      <h3>参赛类别</h3>
      <p>大赛设置了绘画创作、摄影二次创作、文学创作三个类别。参赛作品涵盖了水彩画、油画、数码绘画、创意摄影、短篇小说、诗歌等多种形式，展现了粉丝们丰富的想象力和创造力。</p>
      
      <h3>评审过程</h3>
      <p>评审团由朝桐光本人、知名插画师天野喜孝以及《美术手帖》主编共同组成。朝桐光在评审过程中对每一件入围作品都认真观看，并对粉丝们的用心表示深深的感动。</p>
      
      <h3>获奖名单</h3>
      <p>最终评选出各类别金奖1名、银奖2名、铜奖3名以及优秀奖若干。所有获奖作品将在官方粉丝俱乐部网站进行为期一个月的线上展览，并有机会被收录进下一期官方粉丝杂志。</p>
    `,
    category: 'community',
    coverImage: 'https://readdy.ai/api/search-image?query=Art%20exhibition%20featuring%20fan%20art%20of%20Japanese%20actress%2C%20warm%20gallery%20lighting%2C%20minimalist%20white%20walls%2C%20elegant%20presentation%2C%20creative%20atmosphere%2C%20professional%20photography&width=800&height=450&seq=asa-comm-02&orientation=landscape',
    author: '社区部',
    publishDate: '2025-11-25',
    tags: ['粉丝创作', '大赛', '绘画', '摄影', '文学'],
    featured: false,
    viewCount: 6540,
  },
  {
    id: 'interviews-2025-01',
    title: '朝桐光独家访谈：关于成长、选择与未来的想望',
    excerpt: '在本站独家专访中，朝桐光罕见地敞开内心，谈及从新人到成名的心路历程、演艺道路上的关键选择，以及对未来事业的规划与期待。这篇深入对话展现了一个真实、立体、充满思考的朝桐光。',
    content: `
      <p>在一个初冬的午后，我们有幸与朝桐光进行了一场深入的对话。在东京一间安静的茶室里，朝桐光以最放松的状态接受了我们的独家专访，分享了许多从未公开的心路历程。</p>
      
      <h3>关于成长</h3>
      <p><strong>记者：回顾从出道到现在，最大的成长是什么？</strong></p>
      <p>朝桐光：最大的成长可能是学会了接纳不完美的自己。刚出道的时候，我总是想要做到最好，每一个细节都不允许自己犯错。但后来我渐渐明白，真正的成长不是变得完美，而是学会与自己的不足和平相处，然后在此基础上不断进步。</p>
      
      <h3>关于选择</h3>
      <p><strong>记者：在演艺生涯中，有没有某个特别关键的选择？</strong></p>
      <p>朝桐光：接演《东京夜曲》是我至今最重要的选择。当时这个角色的定位和我之前的戏路完全不同，有很多人劝我不要冒险。但我直觉告诉我，这是我必须演的角色。事实证明，正是这个选择让我突破了自我。</p>
      
      <h3>关于未来</h3>
      <p><strong>记者：对于未来有什么规划和期待？</strong></p>
      <p>朝桐光：我希望未来能够尝试更多不同类型的角色，也希望能有机会参与幕后创作。最近我在学习编剧，也许有一天你会看到由我参与编剧的作品。此外，我也希望能够更多地参与公益活动，用我的影响力为社会做一些有意义的事情。</p>
    `,
    category: 'interviews',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20actress%20intimate%20interview%20in%20traditional%20tea%20room%2C%20soft%20natural%20light%20through%20paper%20windows%2C%20calm%20and%20contemplative%20atmosphere%2C%20minimalist%20Japanese%20aesthetic%2C%20warm%20earth%20tones&width=800&height=450&seq=asa-inter-01&orientation=landscape',
    author: '访谈部',
    publishDate: '2025-11-18',
    tags: ['独家访谈', '深度对话', '心路历程', '未来规划'],
    featured: true,
    viewCount: 21500,
  },
  {
    id: 'interviews-2025-02',
    title: '《娱乐周刊》封面人物：朝桐光——从偶像到实力派的蜕变之路',
    excerpt: '朝桐光登上《娱乐周刊》最新一期封面，在长篇报道中详细回顾了从偶像团体成员到独立实力派演员的转型历程，分享了转型期间的挑战、坚持与收获。',
    content: `
      <p>朝桐光登上了《娱乐周刊》12月号的封面，这是她第三次成为该杂志的封面人物。在长达十页的专题报道中，朝桐光坦诚地分享了自己的转型之路。</p>
      
      <h3>偶像时代</h3>
      <p>朝桐光在18岁时以偶像团体成员身份出道，凭借出色的外貌和舞台表现力迅速获得关注。但她坦言，偶像身份虽然给了她进入演艺圈的机会，却也让她感到某种局限。</p>
      
      <h3>转型挑战</h3>
      <p>从偶像转型为演员，朝桐光面临了巨大的挑战。她回忆道："很多人认为偶像出身的人不会演戏，我需要付出比别人多十倍的努力来证明自己。"</p>
      
      <h3>破茧成蝶</h3>
      <p>经过多年的努力和积累，朝桐光最终凭借《东京夜曲》一举突破，获得了业界和观众的广泛认可。如今的她已经成为日本演艺圈最具代表性的实力派女演员之一。</p>
    `,
    category: 'interviews',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20actress%20on%20magazine%20cover%20photoshoot%2C%20fashionable%20and%20confident%2C%20studio%20lighting%2C%20professional%20fashion%20photography%2C%20elegant%20style%2C%20minimalist%20composition%2C%20warm%20tones&width=800&height=450&seq=asa-inter-02&orientation=landscape',
    author: '访谈部',
    publishDate: '2025-11-15',
    tags: ['杂志封面', '转型', '实力派', '娱乐周刊'],
    featured: false,
    viewCount: 16800,
  },
];

export const aboutData = {
  brandName: '朝桐光官方粉丝资讯站',
  introduction: '朝桐光官方粉丝资讯站创立于2020年，是朝桐光在中国及亚洲地区最权威的粉丝资讯平台。我们致力于为喜爱朝桐光的粉丝提供最全面、最及时、最准确的资讯服务。从最新作品动态到深度人物访谈，从精美写真图集到活跃的粉丝社区，我们努力打造一个温馨、专业、有温度的粉丝之家。',
  mission: '成为连接朝桐光与全球华语粉丝的桥梁，传递真实的资讯，凝聚粉丝的热爱。',
  achievements: [
    { number: '50万+', label: '累计访问量' },
    { number: '2000+', label: '资讯文章' },
    { number: '10万+', label: '社区成员' },
    { number: '500+', label: '独家内容' },
  ],
  teamIntro: '我们的团队由一群热爱朝桐光的资深粉丝组成，包括专业的编辑、摄影师、翻译和社区运营人员。我们以粉丝的视角出发，用专业的态度运营，确保每一条资讯都经过严格的核实和精心的编辑。',
  testimonials: [
    {
      content: '这是我最喜欢的信息来源，每次打开都能看到朝桐光的最新动态，更新非常及时，内容也很专业。',
      author: '小樱',
      role: '资深粉丝 / 社区活跃成员',
    },
    {
      content: '作为一个不太会日语的粉丝，这里的翻译文章对我来说太重要了。翻译质量很高，能准确传达朝桐光想表达的意思。',
      author: 'David Chen',
      role: '海外粉丝 / 长期关注者',
    },
    {
      content: '社区氛围特别好，认识了很多志同道合的朋友。大家一起讨论朝桐光的作品，分享自己的创作，真的很开心。',
      author: '花子',
      role: '粉丝创作者 / 社区版主',
    },
  ],
  contact: {
    email: 'contact@plushy.cn',
    weibo: '@朝桐光官方粉丝站',
    wechat: 'AsahiKaru_Fans',
    address: '东京都港区六本木3-2-1 六本木大厦12F',
  },
};